<template>
  <div class="loginpage">
    <div class="fd-out">
      <div class="fd-in">
        <div class="title">
          <div class="login-login">
            <img
              src="~@/assets/images/logo-blue-en.png"
              alt=""
              v-if="this.$i18n.locale == 'en'"
            />
            <img
              src="~@/assets/images/logo-blue.png"
              alt=""
              v-if="this.$i18n.locale == 'zh'"
            />
          </div>
        </div>
        <!-- 完善用户信息  -->
        <div class="outBig outBigb">
          <div class="outdiv">
            <div class="title">
              <h2>{{ $t("common.fullMsg") }}</h2>
              <p>请先完善个人信息，后续可在【个人中心】更改</p>
            </div>
            <el-form
              :model="ruleForm"
              :rules="rules"
              ref="ruleForm"
              size="mini"
              :label-width="$i18n.locale == 'zh' ? '120px' : '220px'"
              class="demo-ruleForm"
            >
              <el-form-item :label="$t('common.account')" prop="account">
                <span :class="ruleForm.account ? '' : 'nullSpan'">{{
                  IsNull(ruleForm.account)
                }}</span>
              </el-form-item>
              <el-form-item :label="$t('common.role')" prop="role">
                <!-- <span>{{ ruleForm.role }}</span> -->
                <span v-if="$i18n.locale == 'en' && ruleForm.roleEn">{{
                  ruleForm.roleEn
                }}</span>
                <span v-else>{{ ruleForm.role }}</span>
              </el-form-item>
              <el-form-item :label="$t('common.name')" prop="name">
                <el-input
                  v-if="editMode"
                  v-model="ruleForm.name"
                  :placeholder="$t('common.pleaseInput')"
                ></el-input>
                <span v-if="!editMode">{{ ruleForm.name }}</span>
              </el-form-item>
              <el-form-item :label="$t('common.sex')" prop="sex">
                <div v-if="editMode">
                  <el-radio v-model="ruleForm.sex" label="男">{{
                    $t("common.Male")
                  }}</el-radio>
                  <el-radio v-model="ruleForm.sex" label="女">{{
                    $t("common.Female")
                  }}</el-radio>
                </div>
                <span v-if="!editMode">{{ ruleForm.sex }}</span>
              </el-form-item>
              <el-form-item :label="$t('common.jigou')" prop="org">
                <el-input
                  v-if="editMode"
                  v-model="ruleForm.org"
                  :placeholder="$t('common.pleaseInput')"
                  type="textarea"
                  maxlength="1000"
                  show-word-limit
                ></el-input>
                <span v-if="!editMode">{{ ruleForm.org }}</span>
                <organ-add-component
                  ref="organ-add-component"
                  @choseOrgan="choseOrgan"
                ></organ-add-component>
              </el-form-item>
              <el-form-item :label="$t('common.bindingEmail')" prop="email">
                <span :class="ruleForm.email ? '' : 'nullSpan'">{{
                  IsNull(ruleForm.email)
                }}</span>
              </el-form-item>
              <el-form-item
                :label="$t('common.bindingPhone')"
                prop="phoneNumber"
              >
                <span :class="ruleForm.phoneNumber ? '' : 'nullSpan'">{{
                  IsNull(ruleForm.phoneNumber)
                }}</span>
              </el-form-item>
              <el-form-item
                :label="$t('common.otherEmail')"
                prop="reserveEmail"
              >
                <el-input
                  v-if="editMode"
                  v-model="ruleForm.reserveEmail"
                  :placeholder="$t('common.emailTip')"
                ></el-input>
                <span
                  v-if="!editMode"
                  :class="ruleForm.reserveEmail ? '' : 'nullSpan'"
                  >{{ IsNull(ruleForm.reserveEmail) }}</span
                >
              </el-form-item>
              <el-form-item
                :label="$t('common.otherPhone')"
                prop="reservePhoneNumber"
              >
                <el-input
                  v-if="editMode"
                  v-model="ruleForm.reservePhoneNumber"
                  placeholder="请填写手机号，以便于联系"
                ></el-input>
                <span
                  v-if="!editMode"
                  :class="ruleForm.reservePhoneNumber ? '' : 'nullSpan'"
                  >{{ IsNull(ruleForm.reservePhoneNumber) }}</span
                >
              </el-form-item>

              <!--      评审员无该项-->
              <el-form-item
                v-if="authorityObj.isShow('#5#64#66')"
                :label="$t('common.isWill')"
                prop="isWillReview"
              >
                <div v-if="editMode">
                  <el-radio v-model="ruleForm.isWillReview" :label="1">{{
                    $t("common.Yes")
                  }}</el-radio>
                  <el-radio v-model="ruleForm.isWillReview" :label="0">{{
                    $t("common.No")
                  }}</el-radio>
                </div>
                <span v-if="!editMode">{{
                  ruleForm.isWillReview == "1"
                    ? $t("common.Yes")
                    : $t("common.No")
                }}</span>
              </el-form-item>
              <el-form-item :label="$t('common.research')" prop="researchField">
                <el-input
                  v-if="editMode"
                  type="textarea"
                  v-model="ruleForm.researchField"
                  :placeholder="$t('common.pleaseInput')"
                ></el-input>
                <span
                  v-if="!editMode"
                  :class="ruleForm.researchField ? '' : 'nullSpan'"
                  >{{ IsNull(ruleForm.researchField) }}</span
                >
              </el-form-item>
              <el-form-item :label="$t('common.remark')" prop="remarks">
                <el-input
                  v-if="editMode"
                  type="textarea"
                  v-model="ruleForm.remarks"
                  :placeholder="$t('common.pleaseInput')"
                ></el-input>
                <span
                  v-if="!editMode"
                  :class="ruleForm.remarks ? '' : 'nullSpan'"
                  >{{ IsNull(ruleForm.remarks) }}</span
                >
              </el-form-item>
              <el-form-item>
                <el-button
                  v-if="!editMode"
                  type="primary"
                  @click="modifyFrom('ruleForm')"
                  >{{ $t("common.edit") }}</el-button
                >
                <!--        <el-button @click="resetForm('ruleForm')">重置</el-button>-->
                <el-button
                  v-if="editMode"
                  type="primary"
                  @click="submitForm('ruleForm')"
                  >{{ $t("common.confirmEdit") }}</el-button
                >
              </el-form-item>
            </el-form>
          </div>
          <div class="userCenterImgOut">
            <el-upload
              class="avatar-uploader"
              :action="uploadUrl"
              :headers="importHeaders"
              :show-file-list="false"
              :on-success="uploadSuccess"
              :before-upload="beforeUpload"
            >
              <el-image
                v-if="ruleForm.icon"
                :src="ruleForm.icon"
                class="avatar"
                fit="cover"
              />
              <img v-else :src="$oss.userIcon" />
              <span class="upload-tip">{{ $t("common.changeUserIcon") }}</span>
            </el-upload>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// 【账号绑定】
// -通过他人所“创建的账号”-
//   首次登录，需进行账号绑定
// 流程：
// 1）选择绑定方式
// 2）邮箱/手机号 验证
// 3）确认-进入页面
import MailTipComponent from "@/components/login/mailTipComponent";
import commonTitle from "@/components/common/commonTitle";
import tagComponent from "@/components/meeting/tagComponent";
import config from "@/api/config";
import organAddComponent from "@/components/paper/createUser/organAddComponent";

export default {
  data() {
    return {
      importHeaders: {
        authorization: "",
      },
      editMode: true, //编辑模式。
      // tags:["主题01"],//征文主题数组。
      ruleForm: {
        account: "",
        role: "",
        name: "",
        sex: "",
        org: "",
        orgCode: "",
        email: "",
        phoneNumber: "",
        reserveEmail: "",
        reservePhoneNumber: "",
        isWillReview: "",
        researchField: "",
        remarks: "",
      },
      rules: {
        name: [
          {
            required: true,
            message: this.$t("msg.enterName"),
            trigger: "blur",
          },
          {
            min: 2,
            max: 300,
            message: this.$t("msg.enterLength"),
            trigger: "blur",
          },
        ],
        org: [
          { required: true, message: this.$t("msg.enterIns"), trigger: "blur" },
        ],
        sex: [
          { required: true, message: this.$t("msg.choseSex"), trigger: "blur" },
        ],
        reserveEmail: [
          { required: true, message: this.$t("common.pleaseInputEmail"), trigger: "blur" },
          {
            pattern:
              /^[a-zA-Z0-9_.-]+@[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)*\.[a-zA-Z0-9]{2,6}$/,
            message: this.$t("msg.rightEmail"),
            trigger: "blur",
          },
        ],
        isWillReview: [
          {
            required: true,
            message: this.$t("common.isWill"),
            trigger: "blur",
          },
        ],
      },

      //请求回的数据
      personInfo: {
        account: "",
        role: "",
        name: "",
        sex: "",
        org: "",
        email: "",
        phoneNumber: "",
        reserveEmail: "",
        reservePhoneNumber: "",
        isWillReview: "",
        researchField: "",
        remarks: "",
        //icon:'https://financial-search.oss-cn-beijing.aliyuncs.com/web-resource/common/user-icon.png',
        icon: "",
      },

      chianFormData: null,
      chianTags: [], //征文主题数组。
      englishFormData: null,
      englishTags: [], //征文主题数组。

      // 头像相关
      // uploadUrl: config.baseURL+ "/file/upload",
      //uploadUrl: 'http://47.104.20.126:20201/financial-search/api'+ "/file/upload",
      uploadUrl: config.baseURL + "/conference/userinfo/stream",
    };
  },
  components: {
    tagComponent,
    commonTitle,
    organAddComponent,
    MailTipComponent,
  },
  created() {
    this.getCrUserInfo();
    this.importHeaders.authorization = this.$store.state.dict.authorization;
  },
  methods: {
    modifyFrom(formName) {
      this.editMode = !this.editMode;
    },
    // clickOrgan() {
    //   this.$refs["organ-add-component"].handleOpen();
    // },
    choseOrgan(item) {
      this.ruleForm.organCode = item.organCode;
      this.ruleForm.org = item.organName;
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.$api.upDataUserInfo(this.ruleForm, "post").then((resData) => {
            if (resData.code == 200) {
              this.$message({
                message: this.$i18n.locale == "en" ? "Success!" : "操作成功！",
                type: "success",
              });
              this.$store.commit("setIsFinishedInfo", true); //防止用户点击浏览器返回按钮
              this.$router.push({ name: "home" });
            } else {
              this.$message({
                message: this.$t("msg.tryAgain"),
                type: "error",
              });
            }
          });
          //this.editMode = !this.editMode;
        }
      });
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
      this.tags = [];
    },
    //头像相关
    // 上传图片成功
    uploadSuccess(res, file) {
      if (res.data.data && res.data.data.fileLink) {
        this.ruleForm.icon = res.data.data.fileLink;
        this.$api.upDataUserInfo(this.ruleForm, "post").then((resData) => {
          if (resData.code == 200) {
            this.$message({
              message: "操作成功！",
              type: "success",
            });
          } else {
            this.$message({
              message: "操作失败，请稍后重试",
              type: "error",
            });
          }
        });
      }
    },

    getCrUserInfo() {
      this.$api.getCrUserInfo({}, "get").then((res) => {
        if (res.code == 200) {
          this.ruleForm = res.data;
          this.ruleForm.phoneNumber = res.data.phone;

          this.toComplementUnerInfo(
            res.data.name,
            res.data.org,
            res.data.sex,
            res.data.reserveEmail,
            res.data.isWillReview,
            res.data.meetingCode
          );
        } else {
          this.$message({
            message: "操作失败，请稍后重试",
            type: "error",
          });
        }
      });
    },
    //完善用户信息
    toComplementUnerInfo(name, org, sex,reserveEmail, isWillReview, adminstr) {
      if (!this.authorityObj.isShow("#5#64#66")) {
        //判断是评审人
        isWillReview = 1;
      }
      if (adminstr == "admin") {
        //判断是管理员
        isWillReview = 1;
      }
      if (name && org && sex &&reserveEmail&& (isWillReview === 1 || isWillReview === 0)) {
        this.$store.commit("setIsFinishedInfo", true);
        this.$router.push({ name: "home" });
      }
    },

    // 上传图片前文件校验
    beforeUpload(file) {
      const isJPG = file.type === "image/jpeg" || file.type == "image/png";
      const isLt2M = file.size / 1024 / 1024 < 2;

      if (!isJPG) {
        this.$message.error("上传头像图片只能是 JPG 格式或 PNG 格式!");
      }
      if (!isLt2M) {
        this.$message.error("上传头像图片大小不能超过 2MB!");
      }
      return isJPG && isLt2M;
    },
  },
};
</script>

<style scoped lang="scss">
//  pc
@media screen and (min-width: 900px) {
  .fd-out {
    display: flex;
    justify-content: center;
    align-items: center;

    .fd-in {
      width: 1000px;
      height: 700px;
      margin-top: 67px;

      .title {
        height: 50px;
        line-height: 50px;
        display: flex;
        h2{
          margin-right: 12px;
        }
        p{
          color: #a2a3a5;
        }
        .login-login {
          height: 18px;
          width: 200px;
          img {
            width: 100%;
            height: 100%;
          }
        }
      }

      .outBig {
        display: flex;
        justify-content: space-around;
        background: #fff;
        padding-top: 12px;
        .outdiv {
          width: 80%;
        }

        .userCenterImgOut {
          .upload-tip {
            display: block;
            margin-top: 15px;
            font-size: 14px;
          }
        }
      }
    }
  }
  .loginpage {
    width: 100%;
    height: 100%;
    background-size: 100% 100%;
    background: #f4f4f5;
    overflow: auto;
  }
}

//android
@media screen and (max-width: 900px) {
  .fd-out {
    display: flex;
    justify-content: center;
    align-items: center;

    .fd-in {
      width: 100%;

      .title {
        height: 40px;

        .login-login {
          height: 18px;
          width: 200px;
          img {
            width: 100%;
            height: 100%;
          }
        }
      }

      .outBig {
        display: flex;
        justify-content: left;
        flex-direction: column;
        align-items: center;
        flex-direction: column-reverse;

        .outdiv {
          width: 90%;
        }

        .userCenterImgOut {
          .upload-tip {
            display: block;
            margin-top: 15px;
            font-size: 14px;
          }
        }
      }
    }
  }
}

.out-box-login {
  .buzhou-div {
    margin: 20px 0px;
  }

  .chose-way-out {
    justify-content: left;
    align-items: center;
    display: flex;
    margin: 16px 0;

    span {
      font-size: 16px;
      display: inline-block;
      cursor: pointer;
      border-bottom: 2px solid rgba(0, 0, 0, 0);
    }

    span.active {
      color: #3774fe;
      border-bottom: 2px solid #3774fe;
    }

    .shu {
      background: #999;
      width: 1px;
      height: 10px;
      margin: 0 10px;
    }
  }

  .sucess-out {
    .sucess-img-out {
      display: flex;
      justify-content: center;
      align-items: center;
      flex-direction: column;

      .sucess-img {
        margin-top: 20px;
        width: 100px;
        height: 100px;
        background-size: 100% 100%;
        background: url(../../assets/login/icon-sucess-mini.png) no-repeat
          center;
      }

      span {
        margin: 0 0 0 10px;
      }
    }
  }

  .binding-out {
    .sucess-img-out {
      display: flex;
      justify-content: center;
      align-items: center;
      flex-direction: column;

      .sucess-img {
        margin-top: 20px;
        width: 100px;
        height: 100px;
        background-size: 100% 100%;
        background: url(../../assets/login/binding.png) no-repeat center;
      }

      span {
        margin: 0 0 0 10px;
      }
    }

    .two-btn-out {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-top: 50px;

      .two-btn-in {
        display: flex;
        justify-content: center;
        align-items: center;
        width: 48%;
        height: 48px;
        box-shadow: 0px 3px 12px 0px rgba(55, 116, 254, 0.46);
        border-radius: 2px;
        border: 1px solid #3774fe;
        font-size: 16px;
        color: #3774fe;
        cursor: pointer;
      }
    }
  }

  .me-button {
    border-radius: 2px;
    background: #3774fe;
    color: #fff;
    height: 48px;
    text-align: center;
    line-height: 48px;
    font-size: 16px;
    cursor: pointer;
    margin-top: 50px;
  }

  .little-btn-div {
    margin-top: 5px;

    .blue14 {
      cursor: pointer;
      color: #3774fe;
      font-size: 14px;
      float: right;
    }
  }

  .little-btn-divv2 {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    margin-top: 55px;
    margin-bottom: 20px;

    span {
      color: #ff625a;
      border: 1px solid #ff625a;
      margin-left: 5px;
      padding: 0 5px;
      cursor: pointer;
    }
  }
}
</style>
<style>
.userCenterImgOut img {
  width: 130px;
  height: 130px;
  border-radius: 100px;
}
</style>